var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex whites",attrs:{"id":"user-setting"}},[_c('div',{staticClass:"setting-l bg-part"},[_c('div',{staticClass:"setting-item"},[_c('router-link',{attrs:{"to":"/userSetting"}},[_vm._v(_vm._s(_vm.$t('seting.pmethod')))])],1)]),_vm._v(" "),_c('div',{staticClass:"setting-r bg-part"},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6f82908","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/userSetting.vue
// module id = null
// module chunks = 